import Styles from './Drawer.module.scss'
import { Drawer } from 'vaul'
import React, { forwardRef } from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { WithFullHeight, WithSnappedTop } from 'components/Drawer/Types'
import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { FocusScope } from '@react-aria/focus'

type Props = Omit<DialogPrimitive.DialogContentProps & React.RefAttributes<HTMLDivElement>, 'ref' | 'className'> & {
  onAnimationEnd?: (open: boolean) => void
  heightDynamic?: boolean
  layoutViewport?: HTMLDivElement | null
  disableAnimation?: boolean
} & WithFullHeight &
  WithSnappedTop

export const Content = observer(
  forwardRef<HTMLDivElement, Props>(
    (
      {
        heightDynamic = false,
        fullHeight = false,
        layoutViewport,
        isSnappedTop = false,
        disableAnimation = false,
        children,
        ...props
      },
      ref,
    ) => {
      return (
        <Drawer.Content
          aria-describedby={undefined}
          style={{ backgroundColor: props.color || 'var(--light-60)' }}
          className={cx(Styles.content, {
            [Styles.fullHeight]: fullHeight,
            [Styles.heightDynamic]: heightDynamic,
            [Styles.fixedBottom]: !!layoutViewport,
            [Styles.snappedTop]: isSnappedTop,
            [Styles.disableAnimation]: disableAnimation,
          })}
          ref={ref}
          {...props}
        >
          <FocusScope>{children}</FocusScope>
        </Drawer.Content>
      )
    },
  ),
)
